import React, { PureComponent } from "react";
import connect from "react-redux/es/connect/connect";
import { DefaultButton, PrimaryButton } from "office-ui-fabric-react/lib/Button";
import { Dialog, DialogType, DialogFooter } from "office-ui-fabric-react/lib/Dialog";
import {
  scaleStage,
  positionStage,
  getStagePosition,
  getStageScale
} from "../../../actions/viewport-actions";
import {
  togglePdfModal,
  togglePipesPdfModal
} from "../../../actions/pdf-actions";
import { buildProjectAutomation, buildPipeProjectAutomation } from "../../../actions/submit-dialog-actions";
import { setProjectStatus } from "../../../actions/project-actions";
import Project from "../../../lib/project";
import BlockUi from "react-block-ui";
import { toast } from "react-toastify";
import { TooltipHost } from "office-ui-fabric-react/lib/Tooltip";
import {
  GLOBAL_PROJECT_TYPE_PIPE,
  GLOBAL_PROJECT_TYPE_CHAMBER,
  CHAMBER_TYPE_ID_MC4500
} from "../../../lib/types";
import { clearRulersOnScreen } from "../../../actions/drawingtoolbar-actions";
import { DialogContent } from "office-ui-fabric-react/lib-commonjs/Dialog";
import MiniCADAPI from "../../../lib/MiniCADAPI";
import { getAlertMailtoTemplate, getProcessingCriteria } from "../../../lib/misc/misc_utils";
import ManifoldSelectors from "../../../reducers/main-manifold-reducer";
import { modalAlertActions } from "../../../actions/modal-alert.actions";
import ProjectService from "../../../lib/services/project-service";
import { addNewBed, convertToMultiBedProject } from "../../../actions/multi-bed-actions";
import ProjectSelectors from "../../../reducers/project-reducer";
import SubProject from "../../../lib/sub-project";
import { Toggle } from "office-ui-fabric-react/lib-commonjs/Toggle";

class DrawingsAndReportsComponent extends PureComponent{
  state = {
    /* the temporary properties to recover scaling and positioning */
    scaleX: 1,
    scaleY: 1,
    positionX: 0,
    positionY: 0,
    /* the modals properties */
    requestingDrawings: false,
    hideDialog: true,
    hideEmptySystemDialog: true,
    contentProps: {
      type: DialogType.normal,
      title: this.props.content[this.props.lang].requestDrawings,
      subText: this.props.content[this.props.lang].requestCurrentProjectDrawings
    },
    EmptySystemContentProps: {
      type: DialogType.normal,
      title: this.props.content[this.props.lang].emptySystem,
      subText: this.props.isMultiBedProject
        ? this.props.content[this.props.lang].multiBedPleaseAddComponentsToYourSystem
        : this.props.content[this.props.lang].pleaseAddComponentsToYourSystem
    },
    modalProps: {
      titleAriaId: "myLabelId",
      subtitleAriaId: "mySubTextId",
      isBlocking: true,
      containerClassName: "ms-dialogMainOverride"
    },
    hideLevel3Alert: true,
    hideLevel2Alert: true,
    hideLevel1Alert: true,
    alertLevel: "",
    processingEntity: {},
    hydroCadToggle: true,
    hideSubmitChamberWarningMessageDialog: true, //Errors on Click SUBMIT, always true
    enableSubmitChamberWarningMessageDialog: false // remember to update on top-bar.component.js SET TO TRUE TO SHOW
  };

  componentDidUpdate( prevProps, prevState, snapshot ) {
    if (this.props.project !== prevProps.project || this.props.user !== prevProps.user) {
      this.setProcessingEntity();
    }
    if (
      this.props.projectType !== "CHAMBER"
      && this.state.hydroCadToggle === true
    ) {
      console.log("componentDidUpdate()->this.state.hydroCadToggle to FALSE: ");
      this.setState({
        hydroCadToggle: false
      });
    }
  }

  async zoom( scaleX, scaleY, positionX, positionY ) {
    this.props.scaleStage(scaleX, scaleY);
    this.props.positionStage(positionX, positionY);
  }

  async submitProjectAutomation( hydroCAD = false ) {

    console.log(`Submit Project Automation hydroCAD:${hydroCAD}`);
    console.log({ hydroCadToggle: this.state.hydroCadToggle });

    setTimeout(() => {
      this.setState({
        requestingDrawings: true
      });
    });

    let stageScale = this.props.getStageScale();
    let stagePosition = this.props.getStagePosition();
    let project_instance = ProjectService.getNewProjectInstance(this.props.project);

    project_instance.generateHydroCAD = this.state.hydroCadToggle;

    if (!project_instance.isMultiBedProject) {
      this.zoom(1.0, 1.0, 0.0, 0.0)
        .then(async () => {
          // const beds = this.props.multiBed.beds;
          let state;

          // Synchronize units on multibeds
          // if (this.props.projectType === GLOBAL_PROJECT_TYPE_CHAMBER) {
          /*for (let  bed of beds) {
            const subProjectInstance = new SubProject(bed.id);
            let automation = await subProjectInstance
              .fetchAutomationState(
                this.props.user.id,
                this.props.resourcesTokens.projects.blobToken,
              );
            automation.language = this.props.project.language;
            automation.region = this.props.project.region;
            automation.units = this.props.unit;
            automation.email.unitName = 'en1';
            await subProjectInstance
              .persistAutomationState(
                automation,
                automation,
                this.props.user.id,
                this.props.resourcesTokens.projects.blobToken
              );
          }*/
          // }
          // EO - Synchronize units on multibeds

          if (this.props.projectType === GLOBAL_PROJECT_TYPE_CHAMBER) {
            state = this.props.buildProjectAutomation();
          } else {
            state = this.props.buildPipeProjectAutomation();
          }

          state = JSON.parse(state.serialize());

          await project_instance
            .persistAutomationState(
              state,
              this.props.user.id,
              this.props.resourcesTokens.projects.blobToken
            );

          await project_instance.persist(
            this.props.user.id,
            this.props.resourcesTokens.projects.tableToken
          );

          let status = await project_instance
            .submitAutomationTask(
              this.props.user.id,
              this.props.idToken,
              this.props.user.mail,
              this.props.accessToken,
              this.state.hydroCadToggle
            );

          if (status) {
            if (status.workItemStatus.includes("fail")) {
              status.workItemStatus = Project.PROCESSING_STATUS.failed;
            }

            this.props.setProjectStatus(status);
            toast.info(this.props.content[this.props.lang].yourDrawingsAreBeignGenerated, {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 4000
            });

          } else {
            toast.error(this.props.content[this.props.lang].unableToRequestDrawings, {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 4000
            });
          }

          await this.zoom(
            stageScale.scaleX,
            stageScale.scaleY,
            stagePosition.positionX,
            stagePosition.positionY
          );

          this.closeDialog();
        })
        .catch(( error ) => {
          console.error(`(!isMultiBedProject) submitProjectAutomation() this.zoom() :: ${error.message}`);
          this.closeDialog();
        });
    } else {
      this.zoom(1.0, 1.0, 0.0, 0.0)
        .then(async () => {
          const beds = this.props.multiBed.beds;
          let state;

          if (this.props.projectType === GLOBAL_PROJECT_TYPE_CHAMBER) {
            state = this.props.buildProjectAutomation();
          } else {
            state = this.props.buildPipeProjectAutomation();
          }

          state = JSON.parse(state.serialize());

          await project_instance
            .persistAutomationState(
              state,
              this.props.user.id,
              this.props.resourcesTokens.projects.blobToken
            );

          await project_instance.persist(
            this.props.user.id,
            this.props.resourcesTokens.projects.tableToken
          );

          let status = await project_instance
            .submitAutomationTask(
              this.props.user.id,
              this.props.idToken,
              this.props.user.mail,
              this.props.accessToken
            );

          if (status) {
            if (status.workItemStatus.includes("fail")) {
              status.workItemStatus = Project.PROCESSING_STATUS.failed;
            }

            this.props.setProjectStatus(status);
            toast.info(this.props.content[this.props.lang].yourDrawingsAreBeignGenerated, {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 4000
            });

          } else {
            toast.error(this.props.content[this.props.lang].unableToRequestDrawings, {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 4000
            });
          }
          this.zoom(
            stageScale.scaleX,
            stageScale.scaleY,
            stagePosition.positionX,
            stagePosition.positionY
          );
          this.closeDialog();
        })
        .catch(( error ) => {
          console.error(`(isMultiBedProject) submitProjectAutomation() this.zoom() :: ${error.message}`);
          this.closeDialog();
        });
    }
  }

  promptDialog = ( hydroCAD = false ) => {
    const {
      content,
      lang,
      isMC4500Deprecated,
      chamberType,
      projectType
    } = this.props;
    const criteria = getProcessingCriteria() || [];
    this.setProcessingEntity();

    if (
      this.bedHasActiveComponents() ||
      projectType === GLOBAL_PROJECT_TYPE_PIPE
    ) {
      if (projectType === GLOBAL_PROJECT_TYPE_CHAMBER) {
        // Prevent submission if this project uses the deprecated MC-4500
        if (chamberType.id === CHAMBER_TYPE_ID_MC4500 && isMC4500Deprecated) {
          this.props.modalAlertActions({
            text: content[lang].MC4500DeprecationAlert,
            btnText: content[lang].ok,
            toggle: true
          });
          return;
        }

        if (this.state.enableSubmitChamberWarningMessageDialog && this.props.isMultiBedProject) { // DO we want to submit or show message
          console.log(`%c this.props.isMultiBedProject === ${this.props.isMultiBedProject} `, "color:red; background-color:yellow;");
          console.log("%c Show Submit Chamber Warning Message Dialog !!!!! ", "color:red; background-color:yellow;");
          this.setState({
            hideSubmitChamberWarningMessageDialog: false
          });
          return;
        }

        const numOfChambers = this.getTotalNumberOfActiveChambers(),
          numOfManifolds = this.getTotalNumberOfManifolds();

        let matchingCriteria = criteria.find(criteriaObj => {
          return numOfChambers >= criteriaObj["chambersMin"]
            && numOfChambers <= criteriaObj["chambersMax"]
            && numOfManifolds >= criteriaObj["manifoldsMin"]
            && numOfManifolds <= criteriaObj["manifoldsMax"];
        });

        if (!matchingCriteria) {
          this.setState({
            hideDialog: false
          });
        } else {
          // Need to log to the alert table here
          const newState = {
            hideDialog: true,
            hideLevel3Alert: !( matchingCriteria.alertType === "LEVEL_3" ),
            hideLevel2Alert: !( matchingCriteria.alertType === "LEVEL_2" ),
            hideLevel1Alert: !( matchingCriteria.alertType === "LEVEL_1" ),
            alertLevel: matchingCriteria.alertType
          };
          this.setState({ ...newState });
          console.log({ ...newState });
          this.executeProcessingLog(matchingCriteria.alertType);
        }
      } else {
        this.setState({
          hideDialog: false
        });
      }
    } else {
      this.setState({
        hideEmptySystemDialog: false
      });
    }
  };

  setProcessingEntity() {
    let projName = "", city = "", state = "", country = "", customer = "", email = "", company = "", phone = "",
      project = this.props.project;

    if (project) {
      projName = project && project.projectName ? project.projectName : "";
      city = project.city;
      state = project.state;
      country = project.country;
      customer = project.engineer;
    }

    if (this.props.user) {
      email = this.props.user.mail;
      company = this.props.user.companyName;
      phone = this.props.user.mobilePhone;
    }
    const chamber = this.props.globals && this.props.globals.chamberType ? this.props.globals.chamberType.name : "";
    const numChambers = this.props.calculations.requiredChambers;
    const unit = this.props.unit;

    this.setState({
      "processingEntity": {
        projName: projName,
        city: city,
        state: state,
        country: country,
        customer: customer,
        email: email,
        company: company,
        phone: phone,
        chamber: chamber,
        numChambers: numChambers,
        unit: unit,
        systemVolume: this.props.totalStorageProvided.toFixed(2)
      }
    });

  }

  executeProcessingLog( alertType ) {
    try {
      const logDataObject = {
        ...this.state.processingEntity
      };

      const userData = {
        userId: this.props.user.id,
        projectId: this.props.project.id,
        alertLevel: alertType,
        regionId: this.props.user.region,
        languageId: this.props.user.languageId,
        country: logDataObject.country
      };

      setTimeout(async () => {
        const processingEntity = this.state.processingEntity;
        await MiniCADAPI
          .postProjectLogRecord(
            processingEntity,
            userData,
            this.props.idToken,
            this.props.accessToken
          );

      }, 200);

    } catch (e) {
      console.error("Error on executeProcessingLog(), err:: ", e.message);
    }

  }

  getTotalNumberOfActiveChambers() {
    return this.props.calculations.requiredChambers;
  }

  getTotalNumberOfManifolds() {
    return this.props.upperManifolds.length + this.props.lowerManifolds.length;
  }

  closeDialog = () => {
    this.setState({
      requestingDrawings: false,
      hideDialog: true,
      hideLevel3Alert: true,
      hideLevel2Alert: true,
      hideLevel1Alert: true
    });
  };

  bedHasActiveComponents() {
    let rows = this.props.chamberRows;
    return rows.some(r => r.getActiveCount() > 0);
  }

  render() {
    const {
      lang,
      content,
      projectType,
      togglePipesPdfModal
    } = this.props;

    const renderButton = ( label, handleClick, flag, disabled ) => {
      disabled = ( this.props.project && this.props.project.projectType !== this.props.projectType && disabled !== null ) || disabled;

      let msg = content[lang].theProjectMustBeSaved;
      if (this.props.project && this.props.project.projectType !== this.props.projectType && disabled !== null) {
        msg = `Project is saved as '${this.props.project.projectType}' but current mode is '${this.props.projectType}'. Please save again as '${this.props.projectType}' to request drawings.`;
      }

      return (
        <React.Fragment>
          {
            disabled
              ? (
                <TooltipHost
                  content={msg}
                  directionalHint="bottom"
                  styles={{ root: { display: "inline-block", width: "100%" } }}
                >
                  <DefaultButton
                    primary
                    text={label}
                    disabled={disabled}
                    onClick={handleClick}
                    style={{ width: "100%", marginBottom: "10px" }}
                  />
                </TooltipHost>
              )
              : (
                <React.Fragment>
                  <DefaultButton
                    primary
                    text={label}
                    disabled={disabled}
                    onClick={handleClick}
                    style={{ width: "100%", marginBottom: "10px" }}
                  />
                  {flag ? <div style={{ height: "10px" }} /> : null}
                </React.Fragment>
              )
          }
        </React.Fragment>
      );
    };

    /* can request drawings flag */
    let dissableRequestDrawings = ( !this.props.project || !this.props.project.id )
      || ( this.props.project.processingStatus !== Project.PROCESSING_STATUS.unsubmitted
        && this.props.project.processingStatus !== Project.PROCESSING_STATUS.success
        && this.props.project.processingStatus !== Project.PROCESSING_STATUS.failed );
    const minWidth = parseInt(( window.innerWidth * .4 ).toString(), 10);
    return (
      <div style={css.card}>
        {
          projectType === GLOBAL_PROJECT_TYPE_CHAMBER
            ? <React.Fragment>
              {renderButton(content[lang].printSystemSpecifications, () => {
                this.props.clearRulersOnScreen(); //Clears scale and measurement rulers
                this.props.togglePdfModal(true);
              }, true, null)}
              {renderButton(content[lang].emailDrawingAndReports, async () => {
                this.props.clearRulersOnScreen(); //Clears scale and measurement rulers
                // this.setState({ hydroCadToggle: true });
                this.promptDialog(false);
              }, false, dissableRequestDrawings)}
            </React.Fragment>
            : <React.Fragment>
              {renderButton(content[lang].printPipeSpecifications, () => {
                this.props.clearRulersOnScreen(); //Clears scale and measurement rulers
                togglePipesPdfModal(true);
              }, true, null)}
              {renderButton(content[lang].emailDrawingAndReports, async () => {
                this.props.clearRulersOnScreen(); //Clears scale and measurement rulers
                this.promptDialog();
              }, false, dissableRequestDrawings)}
            </React.Fragment>
        }

        <Dialog
          hidden={this.state.hideDialog}
          dialogContentProps={this.state.contentProps}
          modalProps={this.state.modalProps}
          onDismiss={this.closeDialog}
        >
          <BlockUi
            tag="div"
            className="loadingBlockUI"
            blocking={this.state.requestingDrawings}
          >
            {( this.props.projectType === "CHAMBER" ) ?
              <div style={{ color: "black" }}>
                {/* CULTEC DISABLED

                <Toggle
                  className="Toggle ms-Toggle_green_back"
                  onClick={() => {
                    this.props.clearRulersOnScreen(); //Clears scale and measurement rulers
                  }}
                  checked={this.state.hydroCadToggle}
                  onChange={( event, value ) => {
                    this.setState({ hydroCadToggle: value });
                  }
                  }
                  onText={content[lang].includeHydroCADYes}
                  offText={content[lang].includeHydroCADNo}
                />*/}
              </div> :
              null
            }
            <DialogFooter>
              <PrimaryButton onClick={async () => {
                this.props.clearRulersOnScreen(); //Clears scale and measurement rulers
                await this.submitProjectAutomation(this.state.hydroCadToggle);  //Affect Hydrocad HERE
              }} text={content[lang].request} />
              <DefaultButton onClick={async () => {
                this.props.clearRulersOnScreen(); //Clears scale and measurement rulers
                this.closeDialog();
              }}
                             text={content[lang].cancel}
                             className={"outline_grey_ads"} />
            </DialogFooter>
          </BlockUi>
        </Dialog>
        <Dialog
          hidden={this.state.hideEmptySystemDialog}
          dialogContentProps={this.state.EmptySystemContentProps}
          modalProps={this.state.modalProps}
          onDismiss={() => {
            this.setState({ hideEmptySystemDialog: true });
          }}
        >
          <DialogFooter>
            <PrimaryButton onClick={() => {
              this.setState({ hideEmptySystemDialog: true });
            }} text={content[lang].ok} />
          </DialogFooter>
        </Dialog>

        <Dialog
          hidden={this.state.hideLevel1Alert && this.state.hideLevel2Alert}
          dialogContentProps={{
            type: DialogType.normal,
            style: { minWidth: "450px" },
            titleId: "alert-level-title",
            title: content[lang].systemProcessingAlertTitle,
            subText: !this.state.hideLevel1Alert ? content[lang].systemProcessingAlertLevel1Text : content[lang].systemProcessingAlertLevel2Text
          }}
          modalProps={{ containerClassName: "alert-level-container" }}
          onDismiss={this.closeDialog}
        >
          <BlockUi
            tag="div"
            className="loadingBlockUI"
            blocking={this.state.requestingDrawings}
          >
            <DialogFooter>
              <div className="alert-level-input-container">
                <PrimaryButton onClick={async () => {
                  await this.submitProjectAutomation();
                }}
                               text={content[lang].request} />
                <DefaultButton onClick={async () => this.closeDialog()}
                               text={content[lang].cancel}
                               className={"outline_grey_ads"} />
              </div>
            </DialogFooter>
          </BlockUi>
        </Dialog>
        <Dialog
          hidden={this.state.hideLevel3Alert}
          dialogContentProps={{
            type: DialogType.normal,
            titleId: "alert-level-3-title",
            title: content[lang].systemProcessingWarningTitle,
            subText: +"<a href='google.com'>Link Here</a>"
          }}
          modalProps={{ containerClassName: "alert-level-container alert-level-3-container" }}
          onDismiss={this.closeDialog}
        >
          <BlockUi
            tag="div"
            className="loadingBlockUI"
            blocking={this.state.requestingDrawings}
          >
            <DialogContent>
              <div
                dangerouslySetInnerHTML={{ __html: `${content[lang].systemProcessingAlertLevel3Text.replace("{0}", `<a href="${getAlertMailtoTemplate(this.state.processingEntity, this.props.region.id, content[lang])}">ADSDesignTool@ads-pipe.com</a>`)}` }}></div>
            </DialogContent>
            <DialogFooter>
              <div className="alert-level-input-container">
                <DefaultButton onClick={async () => this.submitProjectAutomation()} text={content[lang].request} />
                <PrimaryButton style={{ width: "150px" }}
                               href={getAlertMailtoTemplate(this.state.processingEntity, this.props.region.id, content[lang])}
                               text={content[lang].emailAds} className={"outline_grey_ads"} />
                <DefaultButton onClick={async () => this.closeDialog()} text={content[lang].cancel}
                               className={"outline_grey_ads"} />
              </div>
            </DialogFooter>
          </BlockUi>
        </Dialog>

        <Dialog
          hidden={this.state.hideSubmitChamberWarningMessageDialog}
          dialogContentProps={{
            type: DialogType.normal,
            // No need for translation.
            // This is used only to display SUBMIT ERROR MESSAGES,
            subText: "We are currently experiencing an issue with multibed projects and are working diligently to resolve it. To receive " +
              "the project files, please e-mail adsdesigntool@ads-pipe.com and include the user's first and last name, email address as " +
              "well as the project name. A member of our support team will respond with your files as soon as possible. " +
              "We apologize for the inconvenience."
          }}
          modalProps={{
            isBlocking: true,
            containerClassName: "ms-dialogMainOverride"
          }}
          onDismiss={() => {
            this.setState({ hideSubmitChamberWarningMessageDialog: true });
          }}
          containerClassName="usa_customers_alert"
          minWidth={minWidth}
          maxWidth={minWidth}
        >
          <DialogFooter>
            <PrimaryButton onClick={() => {
              this.setState({ hideSubmitChamberWarningMessageDialog: true });
            }} text={content[lang].ok} />
          </DialogFooter>
        </Dialog>

      </div>
    );
  }
}

const css = {
  card: {
    margin: "10px",
    height: "100%"
  }
};

const mapStateToProps = state => {
  return {
    content: state.localization.content,
    lang: state.localization.lang,
    lbl: state.localization.lbl,
    region: state.localization.region,
    unit: state.localization.unit,

    stageX: state.viewport.stageX,
    stageY: state.viewport.stageY,

    project: state.project.project,

    user: state.authentication.user,
    idToken: state.authentication.idToken,
    accessToken: state.authentication.accessToken,
    resourcesTokens: state.authentication.resourcesTokens,

    projectType: state.globals.projectType,

    chamberRows: state.chamberbed.chamberRows,

    upperManifolds: ManifoldSelectors.getManifoldsByType("upper"),
    lowerManifolds: ManifoldSelectors.getManifoldsByType("lower"),

    calculations: state.calculations,

    totalStorageProvided: state.calculations.totalStorageProvided,
    chamberType: state.globals.chamberType,
    isMC4500Deprecated: state.globals.isMC4500Deprecated,
    multiBed: state.multiBed,
    isMultiBedProject: ProjectSelectors.isMultiBedProject(),
    multiBedIsFromDesktop: state.multiBed.isFromDesktop,
    multiBedIsMultiBedDesktopEnabled: state.multiBed.isMultiBedDesktopEnabled
  };
};

const mapDispatchToProps = {
  scaleStage,
  positionStage,
  getStageScale,
  togglePdfModal,
  getStagePosition,
  setProjectStatus,
  togglePipesPdfModal,
  buildProjectAutomation,
  buildPipeProjectAutomation,
  clearRulersOnScreen,
  modalAlertActions,
  addNewBed,
  convertToMultiBedProject
};

export default connect(
  mapStateToProps, mapDispatchToProps
)(DrawingsAndReportsComponent);



// WEBPACK FOOTER //
// ./src/components/LeftMenu/DrawingsAndReports/drawingsAndReports.component.js